import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import i18n from "./services/i18n";
import VueAuthorize from "vue-authorize";
import VueAuthenticate from "vue-authenticate";

Vue.config.productionTip = false;

import authPlugin from "./plugins/auth-plugin";
import { authUrl } from "./constants";
import { usersApi } from "./services/api/user.api";

import VueCookie from "vue-cookies";

Vue.use(authPlugin as any, { router, store, authUrl });

Vue.use(VueAuthenticate, {
  tokenPath: "token"
});
Vue.use(VueCookie);

import "./http-interceptors";

Vue.prototype.$appReady = false;
Vue.prototype.$invalidateAuth = false;

const createRolesPromise = () => {
  return new Promise((resolve, reject) => {
    if (store.state.auth.currentUser) {
      resolve(store.state.auth.currentRoles);
      Vue.prototype.$appReady = true;
    } else {
      Vue.prototype.$appReady = false;
      // else get the current user
      usersApi
        .getCurrentUser()
        .then((response: any) => {
          store.commit("SET_CURRENTUSER", response.data);
          resolve(response.data.roles);
        })
        .catch(error => {
          // no current user -> logout.
          store.dispatch("logout");
          reject(error);
        })
        .finally(() => {
          Vue.prototype.$appReady = true;
        });
    }
  });
};
let rolesPromise;

const authorize = (role: string) => {
  return new Promise((resolve, reject) => {
    if (!rolesPromise) {
      rolesPromise = createRolesPromise();
    }
    if (Vue.prototype.$invalidateAuth) {
      rolesPromise = createRolesPromise();
      Vue.prototype.$invalidateAuth = false;
    }
    rolesPromise
      .then((roles: any) => {
        if (roles.indexOf(role) > -1) {
          resolve();
        }
        reject();
      })
      .catch(error => {
        reject(error);
      });
  });
};

Vue.use(VueAuthorize, {
  roles: {
    superadmin: {
      handler: () => {
        return authorize("SuperAdmin");
      }
    },
    administrator: {
      handler: () => {
        return authorize("Administrator");
      }
    },
    office: {
      handler: () => {
        return authorize("Office");
      }
    },
    driver: {
      handler: () => {
        return authorize("Driver");
      }
    },
  }
});

router.beforeEach((to, from, next) => {
  const app = router.app as any;
  if (from.name === "login") {
    Vue.prototype.$invalidateAuth = true;
  }

  if (!app.$auth.isAuthenticated()) {
    if (to.path === "/passwordReset" || to.path === "/changePassword") {
      next();
    } else if (to.path !== "/login") {
      next({ replace: true, name: "login" });
    }
    next();
    return;
  }
  // if user is logged in but trying to access auth pages
  if (
    to.path === "/passwordReset" ||
    to.path === "/login" ||
    to.path === "/changePassword"
  ) {
    next("/");
  }

  if (to.path === "/") {
    // after login redirect to the right page
    app.$authorize.isAuthorized(["driver"]).then(() => {
      next("/maintenance/products");
      return;
    });
    app.$authorize.isAuthorized(["administrator"]).then(() => {
      next("/maintenance/products");
      return;
    });
    app.$authorize.isAuthorized(["superadmin"]).then(() => {
      next("/maintenance/products");
      return;
    });

    app.$authorize.isAuthorized(["office"]).then(() => {
      // IF surveyor then start on the surveys screen
      next("/maintenance/products");
      return;
    });

    return;
  }

  if (to.meta && to.meta.permissions) {
    const roles = to.meta.permissions.roles;
    app.$authorize
      .isAuthorized(roles)
      .then(() => {
        next();
      })
      .catch(error => {
        if (error && error[0] && error[0].response.status === 401) {
          next("/login");
          return;
        }
        next(to.meta.permissions.redirectTo || "/login");
      });
    return;
  }
  next();
});

new Vue({
  router,
  store,
  i18n,
  // ...globalMixins,
  render: h => h(App)
}).$mount("#app");
